module.exports = __webpack_public_path__ + "static/media/upload.d6de5761.svg";